import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setDescription
} from '../redux/userGroups'

export default function * requestChangeUserGroupDescription (action) {
  const { userGroupId, description } = action.payload

  const optimisticAction = yield optimisticPut(setDescription({
    id: userGroupId,
    description,
  }))

  try {
    yield call(apiAction, 'SetGroupDescription', {
      groupId: userGroupId,
      description,
    })
  } finally {
    optimisticAction.revert()
  }
}
